/**
 * Shared slug utility — converts a label to a URL-safe slug.
 * e.g. "Royal Enfield" → "royal-enfield"
 */
export const slugify = (text) =>
  String(text || '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/--+/g, '-')
    .replace(/^-+|-+$/g, '');

export default slugify;
